import { BrandSettingsByLocation } from '@frontend/api-brand-settings';

type Props = {
  brandSettings: BrandSettingsByLocation;
  fallbackName?: string;
  isBrandSettingsEnabled: boolean;
  locationName: string;
  selectedLocationId: string;
};

export const calculatePracticeName = ({
  brandSettings,
  fallbackName,
  isBrandSettingsEnabled,
  locationName,
  selectedLocationId,
}: Props) => {
  const defaultName = locationName || fallbackName || '';

  // disabled flag => always use locationName or fallbackName
  if (!isBrandSettingsEnabled) return defaultName;

  // enabled flag
  // 1. brandSetting's nickname
  // 2. brandSetting's locationName
  // 3. locationName
  // 4. fallbackName

  const brandSetting = brandSettings[selectedLocationId];
  return brandSetting?.locationNickname || brandSetting?.locationName || defaultName;
};
